import { AuthIntegrationType } from "src/app/config/enums/auth-integration-type.enum";

function isFeng(name: string, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  if (
    decodeURIComponent(results[2].replace(/\+/g, ' ')) != null &&
    decodeURIComponent(results[2].replace(/\+/g, ' ')) !== ''
  ) {
    return true;
  } else {
    return false;
  }
}

function isNewIntegration(
  name: string,
  name2: string,
  url = window.location.href
) {
  if (url.split('?')[1] != null && url.split('&')[1] != null) {
    var var1 = url.split('?')[1].split('=')[0];
    var var2 = url.split('&')[1].split('=')[0];
    var var3 = url.split('&')[1].split('=')[1];

    if (var1 == name && var2 == name2 && var3 == 'stisa') {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function hideHeaderFooter(name: string, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  if (
    decodeURIComponent(results[2].replace(/\+/g, ' ')) != null &&
    decodeURIComponent(results[2].replace(/\+/g, ' ')) !== ''
  ) {
    return true;
  } else {
    return false;
  }
}

export function getEnvironment(env: 'development' | 'production' | 'local') {
  const host = document.location.host.replace('www.', '');
  const domain = host.replace('dev.', '');

  const config = getConfig(env);

  for (const key in config) {
    config[key].maintenance = false;
  }

  if (domain.startsWith('ingressosa.com')) {
    return config.ingressosa;
  } else if (domain.startsWith('sttickets.ingressosa.com')) {
    config.ingressosa.redirectToV2 = false;
    return config.ingressosa
  } else if (domain.startsWith('produtor.ingressosa.com')) {
    config.ingressosa.redirectToV2 = false;
    return config.ingressosa
  } else if (domain.startsWith('ticketou.com')) {
    return config.ticketou
  } else if (domain.startsWith('chamatickets.com.br')) {
    return config.chamatickets
  } else if (domain.startsWith('goianao2025.com.br')) {
    return config.goianao2025
  } else if (domain.startsWith('poraodorock.digitalingressos.com.br')) {
    return config.digitalingressos
  } else if (domain.startsWith('webview.meubilhete.com.br')) {
    return config.webviewmeubilhete
  } else if (domain.startsWith('meubilhete.com.br')) {
    return config.meubilhete
  } else if (domain.startsWith('vaideingresso.com.br')) {
    return config.vaideingresso
  } else if (domain.startsWith('ticketurbano.com.br')) {
    return config.ticketurbano
  } else if (domain.startsWith('comissario.meubilhete.com.br')) {
    config.meubilhete.redirectToV2 = false;
    return config.meubilhete
  } else if (domain.startsWith('produtor.meubilhete.com.br')) {
    config.meubilhete.redirectToV2 = false;
    return config.meubilhete
  } else if (domain.startsWith('cupom.meubilhete.com.br')) {
    config.meubilhete.redirectToV2 = false;
    return config.meubilhete
  } else if (domain.startsWith('cupom.ticketurbano.com.br')) {
    return config.ticketurbano
  }

  return config.ingressosa
}

export function getConfig(env: 'development' | 'production' | 'local') {
  let config: any;
  switch (env) {
    case 'development':
      config = ENVIRONMENT.development;
      break;
    case 'production':
      config = ENVIRONMENT.production;
      break;
    case 'local':
      config = ENVIRONMENT.local;
      break;
  }
  return config;
}

export type EnvDataCompany = {
  apiUrl: string;
  name: string;
  site?: string;
  voucherlink: string;
  zendChatLink: string;
  xAccessPdv: string;
  xAccessToken: string;
  xCommissaryAccessPdv?: string;
  xCommissaryAccessToken?: string;
  companyId: string;
  xAccessPdvFeng: string;
  xAccessTokenFeng: string;
  newIntegration: boolean;
  hideHeaderFooter: boolean;
  fengIntegration: boolean;
  recaptchaKeyV3: string;
  seatsioWorkspaceKey: string;
  keyMercadoPago: string;
  accessKeyId: string;
  secretAccessKey: string;
  email: string;
  bgHeader?: string;
  whiteLogo?: boolean;
  whiteColor?: boolean;
  enableWhatsappLink?: boolean;
  favicon: string;
  hideCategoryShowMonth: boolean;
  showClubsShieldsFilter: boolean;
  primaryColor: string;
  secondaryColor: string;
  showBeOurPartner: boolean;
  showLgpd: boolean;
  showSwiperStates: boolean;
  enableFacialRecognition: boolean;
  enableSolutionsLink: boolean;
  faqUrl: string;
  address: string;
  enableCleverAdvertising: boolean;
  title: string;
  description: string;
  ogTitle: string;
  ogImage: string;
  askFavoriteTeam?: boolean;
  authIntegration?: {
    type: AuthIntegrationType;
    referencialId?: string;
  };
  showCupom?: boolean;
  courtesyToken?: string;
  courtesyAccessToken?: string;
  faceSignUrl?: string;
  redirectToV2?: string;
};

export interface EnvCompanies {
  ingressosa: EnvDataCompany;
  ticketou: EnvDataCompany;
  chamatickets: EnvDataCompany;
  goianao2025: EnvDataCompany;
  digitalingressos: EnvDataCompany;
  meubilhete: EnvDataCompany;
  webviewmeubilhete: EnvDataCompany;
  vaideingresso: EnvDataCompany;
  ticketurbano: EnvDataCompany
}

export interface EnvData {
  development: Partial<EnvCompanies>;
  production: EnvCompanies;
  local: Partial<EnvCompanies>;
}

export const ENVIRONMENT: EnvData = {
  development: {
    ingressosa: {
      apiUrl: 'https://api-dev.acessofacil.com',
      site: "https://ingressosa.com",
      name: 'Ingresso SA',
      zendChatLink: "https://static.zdassets.com/ekr/snippet.js?key=b090e806-d665-43d6-b28c-94c793e1bc1c",
      voucherlink: "https://voucher.ingressosa.com/",
      xAccessPdv: 'd601a396-257b-4633-bf4e-d48193d46003',
      xCommissaryAccessPdv: "f13a0363-0676-4640-b346-481363d63115",
      xCommissaryAccessToken: "0e55137ddf8d34804f559f72303e975bc988c1d2681ba7a50dfCOMISSARIODEV",
      xAccessToken: '1b2b9cc2d98c0873c4e742e6faf189b30758d96ffef697e064e5caff0faa9499',
      xAccessPdvFeng: '519d1ac1-20c8-4179-91f2-dbe88896b5fa',
      companyId: 'e383fdc4-9045-457e-af90-fc4e3b311333',
      xAccessTokenFeng: '99oz9bgcp2vwhd1d5q9mmz0i1t7chcmkrhnaodpeumofzraf58yltkcyq1w69tb',
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LfJ4GArAAAAABcSOHZ9Jfes1KObFNCt4KfVEEcI',
      seatsioWorkspaceKey: '45320376-e9e6-4cf2-93a2-73e16c2facc6',
      keyMercadoPago: 'APP_USR-0a80a523-1025-453b-ba4b-a59fd1b00a0d',
      accessKeyId: 'AKIARZADPUDX3WYYBEUE',
      secretAccessKey: '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',
      email: 'contato@meubilhete.com',
      hideCategoryShowMonth: false,
      showClubsShieldsFilter: false,
      favicon: "../assets/images/ico_isa.png",
      primaryColor: '#425BFF',
      secondaryColor: '#9921FF',
      showBeOurPartner: true,
      showLgpd: false,
      showSwiperStates: true,
      enableFacialRecognition: true,
      enableSolutionsLink: true,
      faqUrl: 'https://ingressosa.zendesk.com/hc/pt-br',
      address: 'Av. D, Qd. G 11, Lt 01, S/N, Sala 401,<br>Setor Marista<br>Goiânia - Goiás<br>Cep: 74150-040<br>PROCON: 151',
      enableCleverAdvertising: true,
      title: "IngressoSA. Ingressos para eventos, shows e jogos.",
      description: 'IngressoSA. Plataforma de venda de ingressos para shows, eventos e jogos com validação facial, transferência de ingressos e mais.',
      ogTitle: 'IngressoSA. Vendas de Ingressos para shows, eventos e jogos.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/e383fdc4-9045-457e-af90-fc4e3b311333-company-logosite.png',
      faceSignUrl: 'https://dev-app.facesign.in/sso/eb47193a-5538-41ca-ac89-294b6341e74d'

    },
    ticketou: {
      apiUrl: 'https://api-dev.acessofacil.com',
      site: "https://ticketou.com",
      name: 'Ticketou',
      voucherlink: "https://voucher.ticketou.com/",
      xCommissaryAccessPdv: "f13a0363-0676-4640-b346-481363d63115",
      xCommissaryAccessToken: "0e55137ddf8d34804f559f72303e975bc988c1d2681ba7a50dfCOMISSARIODEV",
      zendChatLink: "https://static.zdassets.com/ekr/snippet.js?key=b7c22e99-3617-4b4d-b600-55d8fcb817dd",
      xAccessPdv: 'd601a396-257b-4633-bf4e-d48193d46003',
      xAccessToken: '1b2b9cc2d98c0873c4e742e6faf189b30758d96ffef697e064e5caff0faa9499',
      companyId: 'b33e7ce2-1112-4b9e-b390-0f2b6f76f50f',
      xAccessPdvFeng: '',
      xAccessTokenFeng: '',
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: 'ca73005d-2f35-4e74-9d0d-5398595da9a4',
      keyMercadoPago: 'APP_USR-f59474fb-360a-4d84-b3a4-d0de6c7cf113',
      accessKeyId: '',
      secretAccessKey: '',
      email: 'support@ticketou.zendesk.com',
      favicon: "../assets/images/favico_ticketou.ico",
      hideCategoryShowMonth: false,
      showClubsShieldsFilter: false,
      primaryColor: '#804FB3',
      secondaryColor: '#0d0d0d',
      showBeOurPartner: false,
      showLgpd: false,
      showSwiperStates: false,
      enableFacialRecognition: false,
      enableSolutionsLink: false,
      faqUrl: '',
      address: 'Goiânia GO<br>PROCON: 151',
      enableCleverAdvertising: false,
      title: "Ticketou. Ingressos para eventos e shows.",
      description: 'Ticketou. Plataforma de venda de ingressos para shows e eventos',
      ogTitle: 'Ticketou. Vendas de Ingressos para shows e eventos.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/b33e7ce2-1112-4b9e-b390-0f2b6f76f50f-company-logosite.png'
    },
    chamatickets: {
      apiUrl: 'https://api-dev.acessofacil.com',
      name: 'Chama Tickets',
      voucherlink: "https://voucher.chamatickets.com.br/",
      zendChatLink: "https://static.zdassets.com/ekr/snippet.js?key=b7c22e99-3617-4b4d-b600-55d8fcb817dd",
      xAccessPdv: 'd601a396-257b-4633-bf4e-d48193d46003',
      xAccessToken: '1b2b9cc2d98c0873c4e742e6faf189b30758d96ffef697e064e5caff0faa9499',
      companyId: '6a513fd7-cc7e-48d2-9cd0-4f51abb57854',
      xAccessPdvFeng: '',
      xAccessTokenFeng: '',
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: 'ca73005d-2f35-4e74-9d0d-5398595da9a4',
      keyMercadoPago: 'APP_USR-f59474fb-360a-4d84-b3a4-d0de6c7cf113',
      accessKeyId: '',
      secretAccessKey: '',
      email: 'contato@chamatickets.com.br',
      favicon: "../assets/images/favico_chamatickets.ico",
      hideCategoryShowMonth: true,
      showClubsShieldsFilter: false,
      primaryColor: '#000000',
      secondaryColor: ' #7d7d7d',
      showBeOurPartner: false,
      showLgpd: false,
      showSwiperStates: false,
      enableFacialRecognition: false,
      enableSolutionsLink: false,
      faqUrl: '',
      address: 'Goiânia GO<br>PROCON: 151',
      enableCleverAdvertising: false,
      title: "Chama Tickets. Ingressos para eventos e shows.",
      description: 'Chama Tickets. Plataforma de venda de ingressos para shows e eventos',
      ogTitle: 'Chama Tickets. Vendas de Ingressos para shows e eventos.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/6a513fd7-cc7e-48d2-9cd0-4f51abb57854-company-logosite.png'
    },
    goianao2025: {
      apiUrl: 'https://api.acessofacil.com',
      name: 'Goianão 2025',
      voucherlink: "https://voucher.goianao2025.com.br/",
      zendChatLink: "",
      xAccessPdv: 'e7caedd1-e2c7-448b-9fd0-9e80a35225e2',
      xAccessToken: '9ca29216290ebc7c0c9e3f4f9c0214c8b00b647234889cacb2109035dc337126',
      companyId: '8091d31d-99a9-4383-a208-6b6e9a5f15d6',
      xAccessPdvFeng: '',
      xAccessTokenFeng: '',
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: 'ca73005d-2f35-4e74-9d0d-5398595da9a4',
      keyMercadoPago: 'APP_USR-f59474fb-360a-4d84-b3a4-d0de6c7cf113',
      accessKeyId: '',
      secretAccessKey: '',
      email: 'contato@goianao2025.com.br',
      favicon: "",
      hideCategoryShowMonth: false,
      showClubsShieldsFilter: true,
      primaryColor: '#42a8ff',
      secondaryColor: '#0039ff',
      showBeOurPartner: false,
      showLgpd: false,
      showSwiperStates: false,
      enableFacialRecognition: false,
      enableSolutionsLink: false,
      faqUrl: '',
      address: 'Goiânia GO<br>PROCON: 151',
      enableCleverAdvertising: false,
      title: "Goianão 2025",
      description: 'Goianão 2025. Plataforma de venda de ingressos para jogos do campeonato goiano 2025.',
      ogTitle: 'Goianão 2025. Plataforma de venda de ingressos para jogos do campeonato goiano 2025.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/8091d31d-99a9-4383-a208-6b6e9a5f15d6-company-logosite.png'
    },
    digitalingressos: {
      apiUrl: 'https://api.acessofacil.com',
      name: 'Digital Ingressos',
      voucherlink: "https://voucher.poraodorock.digitalingressos.com.br/",
      zendChatLink: "",
      xAccessPdv: '4d113c5e-dc54-4c34-ae7f-63600ae3f545',
      xAccessToken: 'd73408e852063e325c65cafb6e23cea67b6a14faea56b6fee30a8abc6ae9757c',
      companyId: '1e2abcd7-3258-49b8-9314-31a7167c61f8',
      xAccessPdvFeng: '',
      xAccessTokenFeng: '',
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: 'ca73005d-2f35-4e74-9d0d-5398595da9a4',
      keyMercadoPago: 'APP_USR-f59474fb-360a-4d84-b3a4-d0de6c7cf113',
      accessKeyId: '',
      secretAccessKey: '',
      email: 'contato@digitalingressos.com.br',
      favicon: "../assets/images/favico_digitalingressos.ico",
      hideCategoryShowMonth: true,
      showClubsShieldsFilter: false,
      primaryColor: '#722bae',
      secondaryColor: '#3824db',
      showBeOurPartner: false,
      showLgpd: false,
      showSwiperStates: false,
      enableFacialRecognition: false,
      enableSolutionsLink: false,
      faqUrl: '',
      address: 'Goiânia GO<br>PROCON: 151',
      enableCleverAdvertising: false,
      title: "Digital Ingressos",
      description: 'Digital Ingressos. Vendas de Ingressos para shows e eventos.',
      ogTitle: 'Digital Ingressos. Vendas de Ingressos para shows e eventos.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/1e2abcd7-3258-49b8-9314-31a7167c61f8-company-logosite.png"',
      authIntegration: {
        type: AuthIntegrationType.DIGITAL_INTEGRATION,
      },
    },
    meubilhete: {
      apiUrl: 'https://api.acessofacil.com',
      name: 'MeuBilhete',
      voucherlink: "https://voucher.meubilhete.com.br/",
      zendChatLink: "",
      xAccessPdv: 'd1637f6d-d09c-4025-880a-6361c9e524f1',
      xAccessToken: '0f6b0a76e822151bdc202139286ffbd843d97ec4e07f24356628a7c4a76abcb5',
      companyId: 'c51c9b70-b692-42cb-9821-0945f72f8a2e',
      xAccessPdvFeng: '',
      xAccessTokenFeng: '',
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: 'ca73005d-2f35-4e74-9d0d-5398595da9a4',
      keyMercadoPago: 'APP_USR-f59474fb-360a-4d84-b3a4-d0de6c7cf113',
      accessKeyId: '',
      secretAccessKey: '',
      email: 'contato@meubilhete.com.br',
      favicon: "../assets/images/favico_meubilhete.ico",
      hideCategoryShowMonth: true,
      showClubsShieldsFilter: false,
      primaryColor: '#000000',
      secondaryColor: '#FFFFFF',
      showBeOurPartner: false,
      showLgpd: false,
      showSwiperStates: false,
      enableFacialRecognition: false,
      enableSolutionsLink: true,
      faqUrl: '',
      address: 'Goiânia GO<br>PROCON: 151',
      enableCleverAdvertising: false,
      title: "MeuBilhete",
      description: 'Meu Bilhete. Vendas de Ingressos para shows e eventos.',
      ogTitle: 'Meu Bilhete. Vendas de Ingressos para shows e eventos.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/c51c9b70-b692-42cb-9821-0945f72f8a2e-company-banner.png"',
      authIntegration: {
        type: AuthIntegrationType.TRAUX_TICKETS,
        referencialId: 'e383fdc4-9045-457e-af90-fc4e3b311333',
      },
      showCupom: true
    },
    ticketurbano: {
      apiUrl: 'https://api.acessofacil.com',
      name: 'TicketUrbano',
      voucherlink: "https://voucher.ticketurbano.com.br/",
      zendChatLink: "",
      xAccessPdv: 'b58bfe62-7df9-4875-9db8-3a23a7678a8f',
      xAccessToken: '89649077188c6d693eac445e1fe7d291c5961b78c4f1b25cbf74bb5f27d1a710',
      xCommissaryAccessPdv: "0398b5f1-cd1c-43df-a637-3736ba54486e",
      xCommissaryAccessToken: "0f6b0a76e822151bdc202139286ffbd843d97ec4e07f2435COMISSARIOSTICKETURBANO",
      companyId: '79c77ac4-9106-40dd-b7a7-306f4f2bb176',
      xAccessPdvFeng: '',
      xAccessTokenFeng: '',
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: 'ca73005d-2f35-4e74-9d0d-5398595da9a4',
      keyMercadoPago: 'APP_USR-fb5095dc-9199-4638-840a-c16a906ecce8',
      accessKeyId: '',
      secretAccessKey: '',
      email: 'contato@ticketurbano.com.br',
      favicon: "../assets/images/favico_meubilhete.ico",
      hideCategoryShowMonth: true,
      showClubsShieldsFilter: false,
      primaryColor: '#17132d',
      secondaryColor: '#4d0cb6',
      bgHeader: '#17132d',
      showBeOurPartner: false,
      showLgpd: false,
      showSwiperStates: false,
      enableFacialRecognition: false,
      enableSolutionsLink: false,
      faqUrl: '',
      address: 'Goiânia GO<br>PROCON: 151',
      enableCleverAdvertising: false,
      title: "TicketUrbano",
      description: 'TicketUrbano. Vendas de Ingressos para shows e eventos.',
      ogTitle: 'TicketUrbano. Vendas de Ingressos para shows e eventos.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/c51c9b70-b692-42cb-9821-0945f72f8a2e-company-banner.png"',
      showCupom: true
    },
    vaideingresso: {
      apiUrl: 'https://api.acessofacil.com',
      name: 'VaiDeIngresso',
      voucherlink: "https://voucher.vaideingresso.com.br/",
      zendChatLink: "",
      xAccessPdv: 'b89f7219-f017-4fe4-9d7f-ad72c8db9138',
      xAccessToken: '14690032904dc895c6d4850ff52a55bb820706d344a3a3d6212105b934203dc0',
      companyId: 'ed85426e-627a-4a3f-9b47-0d9e6b7d6f22',
      xAccessPdvFeng: '',
      xAccessTokenFeng: '',
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: 'ca73005d-2f35-4e74-9d0d-5398595da9a4',
      keyMercadoPago: 'APP_USR-f59474fb-360a-4d84-b3a4-d0de6c7cf113',
      accessKeyId: '',
      secretAccessKey: '',
      email: 'contato@vaideingresso.com.br',
      favicon: "../assets/images/favico_meubilhete.ico",
      hideCategoryShowMonth: true,
      showClubsShieldsFilter: false,
      primaryColor: '#000000',
      secondaryColor: '#FFFFFF',
      showBeOurPartner: false,
      showLgpd: false,
      showSwiperStates: false,
      enableFacialRecognition: false,
      enableSolutionsLink: true,
      faqUrl: '',
      address: 'Goiânia GO<br>PROCON: 151',
      enableCleverAdvertising: false,
      title: "VaiDeIngresso",
      description: 'VaiDeIngresso. Vendas de Ingressos para shows e eventos.',
      ogTitle: 'VaiDeIngresso. Vendas de Ingressos para shows e eventos.',
      ogImage: '../assets/images/vaideingressoico.png',
      authIntegration: {
        type: AuthIntegrationType.TRAUX_TICKETS,
        referencialId: 'e383fdc4-9045-457e-af90-fc4e3b311333',
      },
      showCupom: true
    }
  },
  production: {
    ingressosa: {
      apiUrl: 'https://api.acessofacil.com',
      name: 'Ingresso SA',
      site: "https://ingressosa.com",
      voucherlink: "https://voucher.ingressosa.com/",
      // zendChatLink: "https://static.zdassets.com/ekr/snippet.js?key=b090e806-d665-43d6-b28c-94c793e1bc1c",
      zendChatLink: "",
      xAccessPdv: 'c2cd51d1-65e3-4a7f-89cb-ba1b879bf92c',
      xAccessToken: '9ac04be9e350a5e941bf3419a7548adfa9f40b25fdd44a533fc46aeddab3d1aa',
      companyId: 'e383fdc4-9045-457e-af90-fc4e3b311333',
      xAccessPdvFeng: '519d1ac1-20c8-4179-91f2-dbe88896b5fa',
      xAccessTokenFeng: '99oz9bgcp2vwhd1d5q9mmz0i1t7chcmkrhnaodpeumofzraf58yltkcyq1w69tb',
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      enableWhatsappLink: true,
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: '45320376-e9e6-4cf2-93a2-73e16c2facc6',
      keyMercadoPago: 'APP_USR-0a80a523-1025-453b-ba4b-a59fd1b00a0d',
      accessKeyId: 'AKIARZADPUDX3WYYBEUE',
      secretAccessKey: '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',
      email: 'contato@meubilhete.com',
      favicon: "../assets/images/ico_isa.png",
      hideCategoryShowMonth: false,
      showClubsShieldsFilter: false,
      primaryColor: '#425BFF',
      secondaryColor: '#9921FF',
      showBeOurPartner: false,
      showLgpd: true,
      showSwiperStates: true,
      enableFacialRecognition: true,
      enableSolutionsLink: true,
      faqUrl: 'https://ingressosa.zendesk.com/hc/pt-br',
      address: 'Av. 2ª Radial, 69 - St. Pedro Ludovico<br>Goiânia - Goiás<br>Cep: 74820-090<br>PROCON: 151',
      enableCleverAdvertising: true,
      title: "IngressoSA. Ingressos para eventos, shows e jogos.",
      description: 'IngressoSA. Plataforma de venda de ingressos para shows, eventos e jogos com validação facial, transferência de ingressos e mais.',
      ogTitle: 'IngressoSA. Vendas de Ingressos para shows, eventos e jogos.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/e383fdc4-9045-457e-af90-fc4e3b311333-company-logosite.png',
      courtesyToken: '69a71427-1ec7-442a-bcff-03f884834571',
      courtesyAccessToken: '3b2b9cc2d98c0873c4e742e6faf189b30758d96ffef697e064e5caff0faa9499cortesia',
      faceSignUrl: 'https://app.facesign.in/liveness/24e18612-af6f-4fcf-bbf1-7785128323a4',
      redirectToV2: 'https://beta.ingressosa.com'
    },
    ticketou: {
      apiUrl: 'https://api.acessofacil.com',
      name: 'Ticketou',
      site: "https://ticketou.com",
      zendChatLink: "",
      voucherlink: "https://voucher.ticketou.com/",
      xAccessPdv: '861b83a2-6da3-4941-9587-a1723a278f9b',
      xAccessToken: '55f9a0addda20ab2cff91caba4be364727b71fb947bdd36505fa8dee6cd75b62',
      companyId: 'b33e7ce2-1112-4b9e-b390-0f2b6f76f50f',
      xAccessPdvFeng: '',
      xAccessTokenFeng: '',
      xCommissaryAccessPdv: "cdec3021-ee0f-4c45-b564-b4e747554cc6",
      xCommissaryAccessToken: "0f6b0a76e822151bdc202139286ffbd843d97ec4e07f2435COMISSARIOSTICKETOU",
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      enableWhatsappLink: true,
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: '',
      keyMercadoPago: 'APP_USR-6b8d44b6-2dec-4e22-9c76-1309e26e4ff2',
      accessKeyId: '',
      secretAccessKey: '',
      email: 'support@ticketou.zendesk.com',
      favicon: "../assets/images/favico_ticketou.ico",
      hideCategoryShowMonth: false,
      showClubsShieldsFilter: false,
      primaryColor: '#804FB3',
      secondaryColor: '#0d0d0d',
      showBeOurPartner: false,
      showLgpd: false,
      showSwiperStates: false,
      enableFacialRecognition: true,
      enableSolutionsLink: false,
      faqUrl: '',
      address: 'Av. D, Qd. G 11, Lt 01, S/N, Sala 401,<br>Setor Marista<br>Goiânia - Goiás<br>Cep: 74150-040<br>PROCON: 151',
      enableCleverAdvertising: false,
      title: "Ticketou. Ingressos para eventos e shows.",
      description: 'Ticketou. Plataforma de venda de ingressos para shows e eventos',
      ogTitle: 'Ticketou. Vendas de Ingressos para shows e eventos.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/b33e7ce2-1112-4b9e-b390-0f2b6f76f50f-company-logosite.png',
      courtesyToken: '97f7b208-a643-4e81-9325-ef94ddb8ca48',
      courtesyAccessToken: '3b2b9cc2d98c0873c4e742e6faf189b30758d96ffef697e064e5caff0faa9499cortesiaTICKETOU'
    },
    chamatickets: {
      apiUrl: 'https://api.acessofacil.com',
      name: 'Chama Tickets',
      site: "https://chamatickets.com.br",
      voucherlink: "https://voucher.chamatickets.com.br/",
      zendChatLink: "",
      xAccessPdv: 'd3301f75-82f0-4ccb-9486-2fb55f0914c7',
      xAccessToken: '8c03789465aaf91d251a2da9375b674ea31989012e5d318a97afcb1f06202fce',
      companyId: '6a513fd7-cc7e-48d2-9cd0-4f51abb57854',
      xAccessPdvFeng: '',
      xAccessTokenFeng: '',
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      enableWhatsappLink: true,
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: 'ca73005d-2f35-4e74-9d0d-5398595da9a4',
      keyMercadoPago: 'APP_USR-f59474fb-360a-4d84-b3a4-d0de6c7cf113',
      accessKeyId: '',
      secretAccessKey: '',
      email: 'contato@chamatickets.com.br',
      favicon: "../assets/images/favico_chamatickets.ico",
      hideCategoryShowMonth: true,
      showClubsShieldsFilter: false,
      primaryColor: '#000000',
      secondaryColor: ' #7d7d7d',
      showBeOurPartner: false,
      showLgpd: false,
      showSwiperStates: false,
      enableFacialRecognition: false,
      enableSolutionsLink: false,
      faqUrl: '',
      address: 'Goiânia GO<br>PROCON: 151',
      enableCleverAdvertising: false,
      title: "Chama Tickets. Ingressos para eventos e shows.",
      description: 'Chama Tickets. Plataforma de venda de ingressos para shows e eventos',
      ogTitle: 'Chama Tickets. Vendas de Ingressos para shows e eventos.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/6a513fd7-cc7e-48d2-9cd0-4f51abb57854-company-logosite.png'
    },
    goianao2025: {
      apiUrl: 'https://api.acessofacil.com',
      name: 'Goianão 2025',
      site: "https://goianao2025.com.br",
      voucherlink: "https://voucher.goianao2025.com.br/",
      zendChatLink: "",
      xAccessPdv: 'e7caedd1-e2c7-448b-9fd0-9e80a35225e2',
      xAccessToken: '9ca29216290ebc7c0c9e3f4f9c0214c8b00b647234889cacb2109035dc337126',
      companyId: '8091d31d-99a9-4383-a208-6b6e9a5f15d6',
      xAccessPdvFeng: '',
      xAccessTokenFeng: '',
      askFavoriteTeam: true,
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      enableWhatsappLink: true,
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: 'ca73005d-2f35-4e74-9d0d-5398595da9a4',
      keyMercadoPago: 'APP_USR-f59474fb-360a-4d84-b3a4-d0de6c7cf113',
      accessKeyId: '',
      secretAccessKey: '',
      email: 'contato@goianao2025.com.br',
      favicon: "",
      hideCategoryShowMonth: false,
      showClubsShieldsFilter: true,
      primaryColor: '#6fbdff',
      secondaryColor: '#3824db',
      showBeOurPartner: false,
      showLgpd: false,
      showSwiperStates: false,
      enableFacialRecognition: true,
      enableSolutionsLink: false,
      faqUrl: '',
      address: 'Goiânia GO<br>PROCON: 151',
      enableCleverAdvertising: false,
      title: "Goianão 2025",
      description: 'Goianão 2025. Plataforma de venda de ingressos para jogos do campeonato goiano 2025.',
      ogTitle: 'Goianão 2025. Plataforma de venda de ingressos para jogos do campeonato goiano 2025.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/8091d31d-99a9-4383-a208-6b6e9a5f15d6-company-logosite.png',
      authIntegration: {
        type: AuthIntegrationType.TRAUX_TICKETS,
        referencialId: 'e383fdc4-9045-457e-af90-fc4e3b311333',
      },
      //courtesyToken: '89098850-d274-11ef-b265-0e3ee6ea55f3'
    },
    digitalingressos: {
      apiUrl: 'https://api.acessofacil.com',
      name: 'Digital Ingressos',
      site: "https://poraodorock.digitalingressos.com.br",
      voucherlink: "https://voucher.poraodorock.digitalingressos.com.br/",
      zendChatLink: "",
      xAccessPdv: '4d113c5e-dc54-4c34-ae7f-63600ae3f545',
      xAccessToken: 'd73408e852063e325c65cafb6e23cea67b6a14faea56b6fee30a8abc6ae9757c',
      companyId: '1e2abcd7-3258-49b8-9314-31a7167c61f8',
      xAccessPdvFeng: '',
      xAccessTokenFeng: '',
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: 'ca73005d-2f35-4e74-9d0d-5398595da9a4',
      keyMercadoPago: 'APP_USR-f59474fb-360a-4d84-b3a4-d0de6c7cf113',
      accessKeyId: '',
      secretAccessKey: '',
      enableWhatsappLink: true,
      email: 'contato@digitalingressos.com.br',
      favicon: "../assets/images/favico_digitalingressos.ico",
      hideCategoryShowMonth: true,
      showClubsShieldsFilter: false,
      primaryColor: '#722bae',
      secondaryColor: '#11042b',
      showBeOurPartner: false,
      showLgpd: false,
      showSwiperStates: false,
      enableFacialRecognition: false,
      enableSolutionsLink: false,
      faqUrl: '',
      address: 'Brasília-DF<br>PROCON: 151',
      enableCleverAdvertising: false,
      title: "Digital Ingressos",
      description: 'Digital Ingressos. Vendas de Ingressos para shows e eventos.',
      ogTitle: 'Digital Ingressos. Vendas de Ingressos para shows e eventos.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/1e2abcd7-3258-49b8-9314-31a7167c61f8-company-logosite.png"',
      authIntegration: {
        type: AuthIntegrationType.DIGITAL_INTEGRATION,
      },
      showCupom: false,
      courtesyToken: 'e5229913-3b0b-4e8f-99ff-62be9c9859f5',
      courtesyAccessToken: '3b2b9cc2d98c0873c4e742e6faf189b30758d96ffef697e064e5caff0faa9499cortesiaDIGITALINGRESSOS'
    },
    ticketurbano: {
      apiUrl: 'https://api.acessofacil.com',
      name: 'TicketUrbano',
      site: "https://ticketurbano.com.br",
      voucherlink: "https://voucher.ticketurbano.com.br/",
      zendChatLink: "",
      xAccessPdv: 'b58bfe62-7df9-4875-9db8-3a23a7678a8f',
      xAccessToken: '89649077188c6d693eac445e1fe7d291c5961b78c4f1b25cbf74bb5f27d1a710',
      xCommissaryAccessPdv: "0398b5f1-cd1c-43df-a637-3736ba54486e",
      xCommissaryAccessToken: "0f6b0a76e822151bdc202139286ffbd843d97ec4e07f2435COMISSARIOSTICKETURBANO",
      companyId: '79c77ac4-9106-40dd-b7a7-306f4f2bb176',
      xAccessPdvFeng: '',
      xAccessTokenFeng: '',
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: 'ca73005d-2f35-4e74-9d0d-5398595da9a4',
      keyMercadoPago: 'APP_USR-fb5095dc-9199-4638-840a-c16a906ecce8',
      accessKeyId: '',
      secretAccessKey: '',
      email: 'contato@ticketurbano.com.br',
      favicon: "../assets/images/favico_ticketurbano.ico",
      hideCategoryShowMonth: false,
      showClubsShieldsFilter: false,
      enableWhatsappLink: true,
      primaryColor: '#17132d',
      secondaryColor: '#4d0cb6',
      whiteColor: true,
      bgHeader: '#17132d',
      showBeOurPartner: false,
      showLgpd: false,
      showSwiperStates: false,
      enableFacialRecognition: false,
      enableSolutionsLink: false,
      faqUrl: '',
      address: 'Av. 2ª Radial, 69 - St. Pedro Ludovico<br>Goiânia - Goiás<br>Cep: 74820-090<br>PROCON: 151',
      enableCleverAdvertising: false,
      title: "TicketUrbano",
      description: 'TicketUrbano. Vendas de Ingressos para shows e eventos.',
      ogTitle: 'TicketUrbano. Vendas de Ingressos para shows e eventos.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/c51c9b70-b692-42cb-9821-0945f72f8a2e-company-banner.png"',
      showCupom: true
    },
    meubilhete: {
      apiUrl: 'https://api.acessofacil.com',
      site: "https://meubilhete.com.br",
      name: 'MeuBilhete',
      voucherlink: "https://voucher.meubilhete.com.br/",
      zendChatLink: "",
      xAccessPdv: 'd1637f6d-d09c-4025-880a-6361c9e524f1',
      xAccessToken: '0f6b0a76e822151bdc202139286ffbd843d97ec4e07f24356628a7c4a76abcb5',
      companyId: 'c51c9b70-b692-42cb-9821-0945f72f8a2e',
      xAccessPdvFeng: '',
      xAccessTokenFeng: '',
      bgHeader: "#000000",
      xCommissaryAccessPdv: "7719a32b-0b67-4f2f-9291-7066086c987d",
      xCommissaryAccessToken: "0f6b0a76e822151bdc202139286ffbd843d97ec4e07f2435COMISSARIOSMB",
      whiteLogo: true,
      whiteColor: true,
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      enableWhatsappLink: true,
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: '45320376-e9e6-4cf2-93a2-73e16c2facc6',
      keyMercadoPago: 'APP_USR-f59474fb-360a-4d84-b3a4-d0de6c7cf113',
      accessKeyId: '',
      secretAccessKey: '',
      email: 'contato@meubilhete.com.br',
      favicon: "../assets/images/favico_meubilhete.ico",
      hideCategoryShowMonth: true,
      showClubsShieldsFilter: false,
      primaryColor: '#000000',
      secondaryColor: '#7d7d7d',
      showBeOurPartner: false,
      showLgpd: false,
      showSwiperStates: false,
      enableFacialRecognition: true,
      enableSolutionsLink: false,
      faqUrl: '',
      address: 'Av. 2ª Radial, 69 - St. Pedro Ludovico<br>Goiânia - Goiás<br>Cep: 74820-090<br>PROCON: 151',
      enableCleverAdvertising: false,
      title: "MeuBilhete",
      description: 'Meu Bilhete. Vendas de Ingressos para shows e eventos.',
      ogTitle: 'Meu Bilhete. Vendas de Ingressos para shows e eventos.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/c51c9b70-b692-42cb-9821-0945f72f8a2e-company-banner.png"',
      // authIntegration: {
      //   type: AuthIntegrationType.TRAUX_TICKETS,
      //   referencialId: 'e383fdc4-9045-457e-af90-fc4e3b311333',
      // },
      showCupom: true,
      courtesyToken: 'b6095a77-9da1-4a56-9715-2b23819a8488',
      courtesyAccessToken: '3b2b9cc2d98c0873c4e742e6faf189b30758d96ffef697e064e5caff0faa9499cortesiaMB',
      redirectToV2: 'https://beta.meubilhete.com.br'
    },
    vaideingresso: {
      apiUrl: 'https://api.acessofacil.com',
      name: 'VaiDeIngresso',
      site: "https://vaideingresso.com.br",
      voucherlink: "https://voucher.vaideingresso.com.br/",
      zendChatLink: "",
      xAccessPdv: 'b89f7219-f017-4fe4-9d7f-ad72c8db9138',
      xAccessToken: '14690032904dc895c6d4850ff52a55bb820706d344a3a3d6212105b934203dc0',
      companyId: 'ed85426e-627a-4a3f-9b47-0d9e6b7d6f22',
      xAccessPdvFeng: '',
      xAccessTokenFeng: '',
      xCommissaryAccessPdv: "28489f49-8aef-44ce-9da3-20680aedff56",
      xCommissaryAccessToken: "0f6b0a76e822151bdc202139286ffbd843d97ec4e07f2435COMISSARIOSVAIDEINGRESSO",
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: 'ca73005d-2f35-4e74-9d0d-5398595da9a4',
      keyMercadoPago: 'APP_USR-f59474fb-360a-4d84-b3a4-d0de6c7cf113',
      accessKeyId: '',
      secretAccessKey: '',
      enableWhatsappLink: true,
      email: 'contato@vaideingresso.com.br',
      favicon: "../assets/images/vaideingresso.ico",
      hideCategoryShowMonth: true,
      showClubsShieldsFilter: false,
      primaryColor: '#ffb365',
      secondaryColor: '#051642',
      showBeOurPartner: false,
      showLgpd: false,
      showSwiperStates: false,
      enableFacialRecognition: true,
      enableSolutionsLink: true,
      faqUrl: '',
      address: 'Goiânia GO<br>PROCON: 151',
      enableCleverAdvertising: false,
      title: "VaiDeIngresso",
      description: 'VaiDeIngresso. Vendas de Ingressos para shows e eventos.',
      ogTitle: 'VaiDeIngresso. Vendas de Ingressos para shows e eventos.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/ed85426e-627a-4a3f-9b47-0d9e6b7d6f22-company-logosite.png',
      courtesyToken: '8e6e3d2b-93b6-4c93-a273-87b018ee12ea',
      courtesyAccessToken: '519dc186-363e-11f0-8565-0affda5d1fc3cortesias',
      // authIntegration: {
      //   type: AuthIntegrationType.TRAUX_TICKETS,
      //   referencialId: 'e383fdc4-9045-457e-af90-fc4e3b311333',
      // },
      showCupom: true
    },
    webviewmeubilhete: {
      apiUrl: 'https://api.traux.com.br/isa-proxy',
      name: 'MeuBilhete',
      voucherlink: "https://voucher.meubilhete.com.br/",
      zendChatLink: "",
      xAccessPdv: 'd1637f6d-d09c-4025-880a-6361c9e524f1',
      xAccessToken: '0f6b0a76e822151bdc202139286ffbd843d97ec4e07f24356628a7c4a76abcb5',
      companyId: 'c51c9b70-b692-42cb-9821-0945f72f8a2e',
      xAccessPdvFeng: '',
      xAccessTokenFeng: '',
      bgHeader: "#000000",
      whiteLogo: true,
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      enableWhatsappLink: true,
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: 'ca73005d-2f35-4e74-9d0d-5398595da9a4',
      keyMercadoPago: 'APP_USR-f59474fb-360a-4d84-b3a4-d0de6c7cf113',
      accessKeyId: '',
      secretAccessKey: '',
      email: 'contato@meubilhete.com.br',
      favicon: "../assets/images/favico_meubilhete.ico",
      hideCategoryShowMonth: true,
      showClubsShieldsFilter: false,
      primaryColor: '#000000',
      secondaryColor: '#7d7d7d',
      showBeOurPartner: false,
      showLgpd: false,
      showSwiperStates: false,
      enableFacialRecognition: false,
      enableSolutionsLink: false,
      faqUrl: '',
      address: 'Goiânia GO<br>PROCON: 151',
      enableCleverAdvertising: false,
      title: "MeuBilhete",
      description: 'Meu Bilhete. Vendas de Ingressos para shows e eventos.',
      ogTitle: 'Meu Bilhete. Vendas de Ingressos para shows e eventos.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/c51c9b70-b692-42cb-9821-0945f72f8a2e-company-banner.png"',
      authIntegration: {
        type: AuthIntegrationType.TRAUX_TICKETS,
        referencialId: 'e383fdc4-9045-457e-af90-fc4e3b311333',
      },
      showCupom: true,
      courtesyToken: 'b6095a77-9da1-4a56-9715-2b23819a8488',
      courtesyAccessToken: '3b2b9cc2d98c0873c4e742e6faf189b30758d96ffef697e064e5caff0faa9499cortesiaMB'
    },
  },
  local: {
    ingressosa: {
      //apiUrl: 'https://api.acessofacil.com',
      apiUrl: 'http://localhost:3000',
      name: 'Ingresso SA',
      zendChatLink: "https://static.zdassets.com/ekr/snippet.js?key=b090e806-d665-43d6-b28c-94c793e1bc1c",
      voucherlink: "https://voucher.ingressosa.com/",
      xAccessPdv: 'd601a396-257b-4633-bf4e-d48193d46003',
      xAccessToken: '1b2b9cc2d98c0873c4e742e6faf189b30758d96ffef697e064e5caff0faa9499',
      companyId: '8091d31d-99a9-4383-a208-6b6e9a5f15d6',
      xAccessPdvFeng: '519d1ac1-20c8-4179-91f2-dbe88896b5fa',
      xAccessTokenFeng: '99oz9bgcp2vwhd1d5q9mmz0i1t7chcmkrhnaodpeumofzraf58yltkcyq1w69tb',
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: '45320376-e9e6-4cf2-93a2-73e16c2facc6',
      keyMercadoPago: 'APP_USR-0a80a523-1025-453b-ba4b-a59fd1b00a0d',
      accessKeyId: 'AKIARZADPUDX3WYYBEUE',
      secretAccessKey: '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',
      email: 'contato@meubilhete.com',
      hideCategoryShowMonth: false,
      showClubsShieldsFilter: false,
      favicon: "../assets/images/favico_isa.ico",
      primaryColor: '#425BFF',
      secondaryColor: '#9921FF',
      showBeOurPartner: false,
      showLgpd: false,
      showSwiperStates: false,
      enableFacialRecognition: false,
      enableSolutionsLink: false,
      faqUrl: 'https://ingressosa.zendesk.com/hc/pt-br',
      address: 'Av. D, Qd. G 11, Lt 01, S/N, Sala 401,<br>Setor Marista<br>Goiânia - Goiás<br>Cep: 74150-040<br>PROCON: 151',
      enableCleverAdvertising: false,
      title: "IngressoSA. Ingressos para eventos, shows e jogos.",
      description: 'IngressoSA. Plataforma de venda de ingressos para shows, eventos e jogos com validação facial, transferência de ingressos e mais.',
      ogTitle: 'IngressoSA. Vendas de Ingressos para shows, eventos e jogos.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/e383fdc4-9045-457e-af90-fc4e3b311333-company-logosite.png',
      askFavoriteTeam: false,
      showCupom: true
    },
    ticketou: {
      apiUrl: 'http://localhost:3000',
      name: 'Ticketou',
      zendChatLink: "https://static.zdassets.com/ekr/snippet.js?key=b090e806-d665-43d6-b28c-94c793e1bc1c",
      voucherlink: "https://voucher.ingressosa.com/",
      xAccessPdv: 'd601a396-257b-4633-bf4e-d48193d46003',
      xAccessToken: '1b2b9cc2d98c0873c4e742e6faf189b30758d96ffef697e064e5caff0faa9499',
      companyId: 'e265c83b-749e-426a-ad8a-63f09b8677ff',
      xAccessPdvFeng: '519d1ac1-20c8-4179-91f2-dbe88896b5fa',
      xAccessTokenFeng: '99oz9bgcp2vwhd1d5q9mmz0i1t7chcmkrhnaodpeumofzraf58yltkcyq1w69tb',
      newIntegration: isNewIntegration('rfr', 'url'),
      hideHeaderFooter: !!hideHeaderFooter('hideHeaderFooter'),
      fengIntegration: !!isFeng('session'),
      recaptchaKeyV3: '6LcmoFgpAAAAALkUAs_F3mRd2g4FAl3bjXcbDd59',
      seatsioWorkspaceKey: '45320376-e9e6-4cf2-93a2-73e16c2facc6',
      keyMercadoPago: 'APP_USR-0a80a523-1025-453b-ba4b-a59fd1b00a0d',
      accessKeyId: 'AKIARZADPUDX3WYYBEUE',
      secretAccessKey: '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',
      email: 'contato@meubilhete.com',
      hideCategoryShowMonth: false,
      showClubsShieldsFilter: false,
      xCommissaryAccessPdv: "f13a0363-0676-4640-b346-481363d63115",
      xCommissaryAccessToken: "0e55137ddf8d34804f559f72303e975bc988c1d2681ba7a50dfCOMISSARIODEV",
      favicon: "../assets/images/favico_isa.ico",
      primaryColor: '#425BFF',
      secondaryColor: '#9921FF',
      showBeOurPartner: true,
      showLgpd: false,
      showSwiperStates: true,
      enableFacialRecognition: true,
      enableSolutionsLink: true,
      faqUrl: 'https://ingressosa.zendesk.com/hc/pt-br',
      address: 'Av. D, Qd. G 11, Lt 01, S/N, Sala 401,<br>Setor Marista<br>Goiânia - Goiás<br>Cep: 74150-040<br>PROCON: 151',
      enableCleverAdvertising: true,
      title: "IngressoSA. Ingressos para eventos, shows e jogos.",
      description: 'IngressoSA. Plataforma de venda de ingressos para shows, eventos e jogos com validação facial, transferência de ingressos e mais.',
      ogTitle: 'IngressoSA. Vendas de Ingressos para shows, eventos e jogos.',
      ogImage: 'https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/e383fdc4-9045-457e-af90-fc4e3b311333-company-logosite.png',
      askFavoriteTeam: true,
      authIntegration: {
        type: AuthIntegrationType.TRAUX_TICKETS,
        referencialId: 'e383fdc4-9045-457e-af90-fc4e3b311333',
      },
      showCupom: true
    },
  }
};

